// src/pages/couponconfirmation.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { ProtectedLayout } from '../components/ProtectedLayout';

export function CouponConfirmation() {
  const navigate = useNavigate();
  const [couponCode, setCouponCode] = useState<string | null>(null);
  const [userName, setUserName] = useState<string>('Friend');
  const [trialDays, setTrialDays] = useState<number>(7); // Default fallback
  const [endDate, setEndDate] = useState<string | null>(null);

  useEffect(() => {
    const storedCode = sessionStorage.getItem('couponCode');
    const storedName = sessionStorage.getItem('couponName');
    const storedDays = sessionStorage.getItem('couponDays');
    const storedEndDate = sessionStorage.getItem('couponEndDate');

    if (storedCode) setCouponCode(storedCode);
    if (storedName) setUserName(storedName.split(' ')[0]);
    if (storedDays) setTrialDays(parseInt(storedDays, 10));
    if (storedEndDate) {
      const formatted = new Date(storedEndDate).toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
      });
      setEndDate(formatted);
    }

    // Optional: clear after use
    sessionStorage.removeItem('couponCode');
    sessionStorage.removeItem('couponName');
    sessionStorage.removeItem('couponDays');
    sessionStorage.removeItem('couponEndDate');
  }, []);

  return (
    <ProtectedLayout>
      <div className="min-h-screen flex flex-col items-center justify-center px-6 py-16 bg-gradient-to-b from-white to-blue-50">
        <div className="max-w-xl w-full bg-white rounded-xl shadow-xl p-8 text-center space-y-6 border-t-4 border-gray-200">
          <div className="absolute top-0 left-0 w-full h-4 bg-gradient-to-b from-gray-300 to-transparent backdrop-blur-sm z-10" />

          <h1 className="text-3xl font-bold text-[#004060]">Congrats, {userName}! You're In.</h1>

          <p className="text-lg text-gray-700">
            Your coupon{couponCode ? ` (${couponCode})` : ''} has been applied.
          </p>

          <p className="text-md text-gray-600">
            You now have full access to the FearGo App for {trialDays} {trialDays === 1 ? 'day' : 'days'}.
            We'll check in before {endDate ?? 'your trial ends'} to see how it's going.
          </p>

          <p className="text-md text-gray-600">
            Let's get started with clarifying three core values. The good news is that it only takes three questions.
          </p>

          <Button onClick={() => navigate('/impactintentions')} className="w-full">
            Let's Go!
          </Button>
        </div>
      </div>
    </ProtectedLayout>
  );
}
